/* post-t7-1 M4: EL COLCHON DEL CENTRO DE ESTUDIO CRECE CON EL AVISO.
 *
 * La barra de accion del Centro (en el telefono) es fija y lleva arriba de su boton un renglon: el resumen, o el aviso
 * de por que el boton esta apagado, que parte renglon (t7-3 remate 8, #591). La pagina reserva abajo un colchon FIJO
 * (en post-t7-1 eran 80 px en StudyCenter.js; hoy la holgura del Centro, 120) pensado para la barra con UN renglon. Medido en Chrome (320, 375 y 390, web y
 * app): con el aviso en dos renglones la barra mide 16.5 px mas y en web tapa 7 px del ultimo elemento; con tres, 23.5
 * (y 12.5 en la app).
 *
 * Aqui se mide cuanto de mas mide ese renglon (su alto menos una linea) y la pagina suma eso a su colchon. Con un
 * renglon el extra es 0 y la pagina queda exactamente como antes (ni estilo en linea). En computadora la barra esta
 * oculta: el renglon mide 0 y el extra tambien. Sin ResizeObserver (jsdom), 0. */
import { useCallback, useRef, useState } from 'react';

/** El colchon de la pagina con un renglon (en post-t7-1, 80 px).
 *  pantallas-alumno (C): la barra fija nueva (resumen de 18 y boton de 52) reserva 120
 *  (`HOLGURA_DEL_CENTRO` de StudyCenter.js). */
export const COLCHON_DEL_CENTRO_PX = 120;

/** Lo que el renglon mide de mas sobre UNA linea, en px enteros (0 si no hay medida). */
export function extraDeRenglones(alto, interlineado) {
  if (!(alto > 0) || !(interlineado > 0)) return 0;
  return Math.max(0, Math.round(alto - interlineado));
}

/** `[ref, extra]`: el `ref` va en el renglon del aviso; `extra` lo que la pagina suma a su colchon. */
export function useExtraDelAviso() {
  const [extra, setExtra] = useState(0);
  const observador = useRef(null);
  const ref = useCallback((el) => {
    if (observador.current) {
      observador.current.disconnect();
      observador.current = null;
    }
    if (!el) {
      setExtra(0);
      return;
    }
    if (typeof window === 'undefined' || typeof window.ResizeObserver !== 'function') return;
    const medir = () => {
      const interlineado = parseFloat(window.getComputedStyle(el).lineHeight);
      const nuevo = extraDeRenglones(el.getBoundingClientRect().height, interlineado);
      setExtra((v) => (v === nuevo ? v : nuevo));
    };
    observador.current = new window.ResizeObserver(medir);
    observador.current.observe(el);
    medir();
  }, []);
  return [ref, extra];
}
